import { useMemo } from 'react'
import { Radio } from '@mui/material'
import { t } from 'i18next'
import EnhancedTable from 'src/components/shared/EnhancedTable/EnhancedTable'
import IconExtension from 'src/components/shared/ui/IconExtension'
import { Document } from 'src/interfaces/lexon'

type Props = {
  search: string
  title?: string
  data?: Document[]
  isExpedientType?: boolean
  selectedDocument: Document | null
  setSelectedDocument: (row: Document[]) => void
}

export default function TableDocuments(props: Props): JSX.Element {
  const {
    data = [],
    setSelectedDocument,
    selectedDocument,
    search = '',
    title = '',
    isExpedientType = false
  } = props

  const columns = useMemo(
    () => [
      {
        id: 'selection',
        Header: () => null,
        width: 25,
        Cell: ({ row }) => (
          <Radio
            {...row.getToggleRowSelectedProps()}
            indeterminate="false"
            title="click para seleccionar"
            inputProps={{ 'aria-label': 'click para seleccionar' }}
          />
        )
      },
      {
        Header: t('components.enhanced_table.header.type'),
        accessor: (document: Document) => {
          return <IconExtension fileName={document.initialFile} />
        },
        width: 30
      },
      {
        Header: t('components.enhanced_table.header.origin'),
        accessor: 'origin',
        width: 80
      },
      {
        Header: t('components.enhanced_table.header.initialFile'),
        accessor: 'initialFile'
      },
      {
        Header: t('components.enhanced_table.header.name'),
        accessor: 'name'
      }
    ],
    []
  )

  return (
    <EnhancedTable
      title={title}
      search={search}
      variation="modal"
      fixed
      hoverRows
      selectRows
      multiSelect={false}
      columns={columns}
      data={data}
      toolbar
      noRegistersMessage={
        isExpedientType
          ? t('components.enhanced_table.no_registers.lexon_expedient_documents')
          : t('components.enhanced_table.no_registers.lexon_documents')
      }
      noRegisterIcon
      required={false}
      onRowSelectStateChange={setSelectedDocument}
      rowSelect={selectedDocument}
    />
  )
}
